import { Column, DataDisplayType } from '@navstation-portal/reporting/data-model/ui';

// ReportType lives in the plural library, because the list names a report type
// too. This re-export keeps the imports of the report under edit as they were.
export { ReportType } from '@navstation-portal/reporting/data-model/vessel-reports';

// ensure that the enum keys of ReportType and ReportRoute are the same
export const ReportRoutes = {
  Anchor: 'anchor-drifting-report',
  Sea: 'sea-report',
  Departure: 'departure-report',
  Port: 'port-report',
  Maneuvering: 'maneuvering-report',
  SeaArrival: 'sea-arrival-report',
  Drifting: 'anchor-drifting-report',
} as const;
export type ReportRoute = (typeof ReportRoutes)[keyof typeof ReportRoutes];

export function isReportRoute(value: string): value is ReportRoute {
  return Object.values(ReportRoutes).includes(value as ReportRoute);
}

export type { ReducedVesselReport } from '@navstation-portal/reporting/data-model/vessel-reports';

export const cols: Column[] = [
  { field: 'reportNumber', header: '#', type: DataDisplayType.Integral },
  { field: 'reportFrom', header: 'Report  From', type: DataDisplayType.Date },
  { field: 'reportTo', header: 'Report To', type: DataDisplayType.Date },
  {
    field: 'reportPeriod',
    header: 'Report Period',
    type: DataDisplayType.DecimalHours,
  },
  { field: 'reportType', header: 'Report Type', type: DataDisplayType.ReportBadge },
  { field: 'bfScale', header: 'BF', type: DataDisplayType.Integral },
  {
    field: 'meanDraught',
    header: 'Mean Draught (m)',
    type: DataDisplayType.Decimal1,
  },
  {
    field: 'consumption',
    header: 'ME Consumption (MT/24Hrs)',
    type: DataDisplayType.Decimal2,
  },
  {
    field: 'avgSpeed',
    header: 'GPS Speed (kn)',
    type: DataDisplayType.Decimal1,
  },
  {
    field: 'logSpeed',
    header: 'Log Speed (kn)',
    type: DataDisplayType.Decimal1,
  },
  { field: 'status', header: 'Status', type: DataDisplayType.Icon },
];
